// frontend/src/ui/Page.jsx
import React from "react";

/**
 * Page: global wrapper that horizontally centers content,
 * keeps top-aligned layout, and respects mobile single-column,
 * using your existing .app-page styles.
 */
export default function Page({ children }) {
  return <div className="app-page">{children}</div>;
}
